module.exports = __webpack_public_path__ + "static/media/icon_06.28cae92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_06.png
// module id = 1647
// module chunks = 1